import scrollMonitor from 'scrollmonitor'
import { debounce } from 'debounce'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

class ScrollAnimation {
  constructor() {
    this.animationCount = 1
    this.animationDelay = 1000
    this.isScrolling = false
    this.isAnimating = false
    this.layerOne = document.querySelector('.js-animated-content-layer-1')
    this.layerTwo = document.querySelector('.js-animated-content-layer-2')
    this.layerThree = document.querySelector('.js-animated-content-layer-3')
    this.layerFour = document.querySelector('.js-animated-content-layer-4')
    this.largePulse = document.querySelector('.js-animated-content-pulse')
    this.secondLargePulse = document.querySelector('.js-animated-content-pulse-second')
    this.wrapper = document.querySelector('.js-animated-content-wrapper')
    this.container = document.querySelector('.js-animated-content')
    this.isFinished = false;
  }

  start() {
    const scrollContainer = document.querySelector('.js-animated-content-scroll')

    if (!this.container) return

    // Watchers
    const watcherContainer = scrollMonitor.create(this.container)

    watcherContainer.fullyEnterViewport(() => {
      if (!this.isFinished) {
        this.container.classList.add('fixed')
        this.wrapper.classList.add('full-view')
        this.layerOne.classList.add('fixed')
        this.layerTwo.classList.add('hidden')
        this.layerThree.classList.add('hidden')
        this.layerFour.classList.add('hidden')
  
        disableBodyScroll(this.wrapper)
  
        this.animate()
  
        scrollContainer.addEventListener('scroll', e => {
          if (!this.isScrolling && !this.isAnimating) this.animate()
  
          this.isScrolling = true
  
          window.setTimeout(() => {
            this.isScrolling = false
          }, 500)
        })
      }
    })
  }

  animate() {
    this.layerOne.classList.add('animation-1')
    if (this.animationCount === 1) {
      console.log('starting stap 1')
      this.isAnimating = true
      window.setTimeout(e => {
        this.layerOne.classList.add('animation-1-hidden')
        this.largePulse.classList.add('active')
        this.animationCount++
        console.log('stap 1')
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 2) {
      console.log('starting stap 2')
      this.isAnimating = true
      window.setTimeout(e => {
        this.layerOne.classList.add('animation-1-hidden')
        this.animationCount++
        console.log('stap 2')
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 3) {
      console.log('starting stap 3')
      this.isAnimating = true
      window.setTimeout(e => {
        this.largePulse.classList.add('active')
        console.log('stap 3')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 4) {
      this.isAnimating = true
      console.log('starting stap 4')
      window.setTimeout(e => {
        this.largePulse.classList.add('pulse-increase')
        this.largePulse.classList.remove('active')

        this.layerOne.classList.add('fixed')
        this.layerTwo.classList.add('hidden')
        this.layerTwo.classList.remove('fixed')
        this.largePulse.classList.remove('pulse-hidden')
        this.secondLargePulse.classList.remove('pulse-hidden')
        this.animationCount++
        console.log('stap 4')
        this.isAnimating = false
      }, 1500)
    }

    if (this.animationCount === 5) {
      console.log('starting stap 5')
      this.isAnimating = true
      window.setTimeout(e => {
        this.layerTwo.classList.remove('hidden')
        this.layerTwo.classList.add('fixed')
        this.layerOne.classList.remove('fixed')
        this.layerOne.classList.add('hidden')
        this.layerTwo.classList.remove('active')
        this.secondLargePulse.classList.add('pulse-increase')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 6) {
      this.isAnimating = true
      console.log('starting stap 6')
      window.setTimeout(e => {
        this.secondLargePulse.classList.remove('pulse-increase')
        this.secondLargePulse.classList.remove('pulse-hidden')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 7) {
      this.isAnimating = true
      console.log('starting stap 7')
      window.setTimeout(e => {
        this.secondLargePulse.classList.add('pulse-hidden')
        this.layerTwo.classList.remove('active')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 8) {
      this.isAnimating = true
      console.log('starting stap 8')
      window.setTimeout(e => {
        this.layerTwo.classList.add('active')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 9) {
      console.log('starting stap 9')
      this.isAnimating = true
      window.setTimeout(e => {
        this.layerTwo.classList.remove('active')

        this.layerThree.classList.add('hidden')
        this.layerThree.classList.remove('fixed')
        this.layerTwo.classList.remove('zoom-image')
        this.layerThree.classList.remove('fadein-image')
        this.animationCount++
        this.isAnimating = false
      }, 3000)
    }

    if (this.animationCount === 10) {
      this.isAnimating = true
      console.log('starting stap 10')
      window.setTimeout(e => {
        this.layerTwo.classList.add('zoom-image')

        this.layerThree.classList.remove('hidden')
        this.layerThree.classList.add('fixed')
        this.layerThree.classList.add('fadein-image')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 11) {
      this.isAnimating = true
      console.log('starting stap 11')
      window.setTimeout(e => {
        this.layerTwo.classList.remove('fixed')
        this.layerTwo.classList.add('hidden')
        this.layerTwo.classList.remove('zoom-image')
        this.layerThree.classList.remove('active')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 12) {
      this.isAnimating = true
      console.log('starting stap 12')
      window.setTimeout(e => {
        this.layerThree.classList.add('active')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 13) {
      this.isAnimating = true
      console.log('starting stap 13')
      window.setTimeout(e => {
        this.layerThree.classList.remove('active')
        this.layerFour.classList.add('hidden')
        this.layerFour.classList.remove('fixed')
        this.layerThree.classList.remove('zoom-image')
        this.layerFour.classList.remove('fadein-image')
        this.animationCount++
        this.isAnimating = false
      }, 3000)
    }

    if (this.animationCount === 14) {
      this.isAnimating = true
      console.log('starting stap 14')
      window.setTimeout(e => {
        this.layerThree.classList.add('zoom-image')

        this.layerFour.classList.remove('hidden')
        this.layerFour.classList.add('fixed')
        this.layerFour.classList.add('fadein-image')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 15) {
      this.isAnimating = true
      console.log('starting stap 15')
      window.setTimeout(e => {
        this.layerThree.classList.remove('fixed')
        this.layerThree.classList.add('hidden')
        this.layerThree.classList.remove('zoom-image')
        this.layerFour.classList.remove('active')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 16) {
      this.isAnimating = true
      console.log('starting stap 16')
      window.setTimeout(e => {
        this.layerFour.classList.remove('active')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 17) {
      this.isAnimating = true
      console.log('starting stap 17')
      window.setTimeout(e => {
        this.layerFour.classList.add('active')
        this.layerFour.classList.add('fixed')
        this.animationCount++
        this.isAnimating = false
      }, 1000)
    }

    if (this.animationCount === 18) {
      this.isAnimating = true
      console.log('starting stap 18')
      window.setTimeout(e => {
        this.layerFour.classList.remove('fixed')
        this.wrapper.classList.remove('full-view')
        this.container.classList.remove('fixed')
        this.layerTwo.classList.add('active')
        this.layerThree.classList.add('active')

        enableBodyScroll(this.wrapper)

        this.isFinished = true
        this.layerTwo.classList.remove('hidden')
        this.layerThree.classList.remove('hidden')

        document.getElementById('c-animation-three-layers__end').scrollIntoView();
      }, 1000)
    }
  }
}

export default ScrollAnimation


// WEBPACK FOOTER //
// ./src/js/modules/ScrollAnimation.js